import { parsePhoneNumberFromString } from "libphonenumber-js";

// Deixa o número do WhatsApp legível.
//
// O que vem do WhatsApp é só dígito: "556196080740". Lido assim, ninguém
// reconhece o próprio contato — e conferir se é o número certo antes de
// apagar ou abrir conversa vira exercício de contar caracteres.
//
// Grupo não tem telefone: o identificador é um número longo do próprio
// WhatsApp, e formatá-lo como celular seria mentira.

// Celular brasileiro: 55 + DDD (2) + 9 dígitos.  → +55 (61) 99608-0740
// Fixo brasileiro:    55 + DDD (2) + 8 dígitos.  → +55 (61) 3608-0740
//
// O Brasil continua com forma própria aqui: a libphonenumber escreveria
// "+55 61 99608-0740", sem os parênteses do DDD, e a agenda inteira mudaria de
// aparência sem ninguém ter pedido.
const BRASIL_CELULAR = /^55(\d{2})(\d{5})(\d{4})$/;
const BRASIL_FIXO = /^55(\d{2})(\d{4})(\d{4})$/;

const analisar = (digitos) => {
  try {
    return parsePhoneNumberFromString(`+${digitos}`) || null;
  } catch {
    return null;
  }
};

export const formatarNumero = (valor, ehGrupo = false) => {
  const digitos = String(valor || "").replace(/\D/g, "");

  if (!digitos) return "";

  // O id de grupo passa de 15 dígitos e não tem forma de telefone.
  if (ehGrupo || digitos.length > 15) return digitos;

  const celular = BRASIL_CELULAR.exec(digitos);
  if (celular) {
    return `+55 (${celular[1]}) ${celular[2]}-${celular[3]}`;
  }

  const fixo = BRASIL_FIXO.exec(digitos);
  if (fixo) {
    return `+55 (${fixo[1]}) ${fixo[2]}-${fixo[3]}`;
  }

  // Número de fora: quem sabe a forma certa de cada país é a libphonenumber.
  // Antes daqui saía um agrupamento inventado ("+351 2345-6789"), que não é
  // como se escreve telefone em lugar nenhum.
  const telefone = analisar(digitos);

  if (telefone) return telefone.formatInternational();

  // Sem país reconhecido, o agrupamento genérico ainda é melhor que a fila
  // corrida de dígitos.
  if (digitos.length > 6) {
    const inicio = digitos.slice(0, digitos.length - 8);
    const meio = digitos.slice(-8, -4);
    const fim = digitos.slice(-4);
    return `+${inicio} ${meio}-${fim}`;
  }

  return digitos;
};

// De que país é o número — para mostrar a bandeira ao lado dele.
//
// null quando não dá para saber: grupo, id do WhatsApp, número truncado. Quem
// exibe cai no globo, em vez de chutar uma bandeira.
export const paisDoNumero = (valor, ehGrupo = false) => {
  const digitos = String(valor || "").replace(/\D/g, "");

  if (!digitos || ehGrupo || digitos.length > 15) return null;

  return analisar(digitos)?.country || null;
};

export default formatarNumero;
